import React from "react";
import {Spin} from "antd";
import style from "./LoadingIndicator.module.scss";


export default function LoadingIndicator({ visible }) {
  return visible && <Spin size="large" className={style.indicator} />;
}
